export enum RequestListType {
  MAP = 1,
  LIST = 2,
  BOTH = 3,
}
